module.exports = __webpack_public_path__ + "img/break.ad97cf42.gif";